

import Menu from "../components/Menu.marko";
import Hero from "../components/Hero.marko";
import Ceremonia from "../components/Ceremonia.marko";
import Rejs from "../components/Rejs.marko";
import Wesele from "../components/Wesele.marko";
import NaszaHistoria from "../components/NaszaHistoria.marko";
import RSVP from "../components/RSVP.marko";
import PhotoCredits from "../components/PhotoCredits.marko";

import "../styles/animations.css";
// import "./animations.js";

<style>
  @import url('https://fonts.googleapis.com/css2?family=Allura&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Meow+Script&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=WindSong:wght@400;500&display=swap');

  @font-face {
    font-family: "Beautifully Delicious Script";
    src: url("../fonts/BeautifullyDeliciousScript.ttf") format("truetype");
    font-weight: 400;
    font-style: normal;
  }
  html {
  scroll-behavior: smooth;
  }
  html,
  body {
    margin: 0;
    padding: 0;

    width: 100%;
    max-width: 100%;

    overflow-x: clip;
  }
</style>
<div id="top"></div>
<Menu />
<Hero />
<Ceremonia />
<Rejs />
<Wesele />
<NaszaHistoria />
<RSVP />
<PhotoCredits />

<script>
  function initRevealAnimations() {
    const revealElements =
      document.querySelectorAll(".reveal");

    const revealObserver =
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
        }
      );

    revealElements.forEach((element) => {
      revealObserver.observe(element);
    });
  }


  function fitWritingTitles() {
    const writingTitles =
      document.querySelectorAll(".writing-title");

    writingTitles.forEach((title) => {

      if (!(title instanceof HTMLElement)) {
        return;
      }

      /*
        Najpierw wracamy do rozmiaru
        wynikającego z CSS.
      */
      title.style.fontSize = "";

      const computedStyle =
        window.getComputedStyle(title);

      const originalFontSize =
        parseFloat(computedStyle.fontSize);

      const availableWidth =
        title.clientWidth * 0.94;

      const contentWidth =
        title.scrollWidth;

      /*
        Jeśli napis jest za szeroki,
        zmniejszamy font dokładnie tyle,
        ile potrzeba.
      */
      if (contentWidth > availableWidth) {
        const ratio =
          availableWidth / contentWidth;

        const newFontSize =
          originalFontSize * ratio;

        title.style.fontSize =
          `${newFontSize}px`;
      }
    });
  }


  function initWritingTitles() {
    const writingTitles =
      document.querySelectorAll(".writing-title");

    writingTitles.forEach((title) => {

      if (!(title instanceof HTMLElement)) {
        return;
      }

      /*
        Nie dzielimy tekstu ponownie,
        jeśli funkcja odpali się drugi raz.
      */
      if (title.dataset.prepared === "true") {
        return;
      }

      const text =
        (title.textContent ?? "").trim();

      title.innerHTML = "";
      title.dataset.prepared = "true";

      [...text].forEach((letter, index) => {
        const span =
          document.createElement("span");

        span.classList.add("letter");

        span.textContent =
          letter === " "
            ? "\u00A0"
            : letter;

        span.style.transitionDelay =
          `${index * 0.08}s`;

        title.appendChild(span);
      });
    });


    /*
      Najpierw tworzymy litery,
      potem dopasowujemy szerokość.
    */
    fitWritingTitles();


    const writingObserver =
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("writing");
              writingObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.35,
        }
      );


    writingTitles.forEach((title) => {
      writingObserver.observe(title);
    });
  }

  // function initMenu() {

  //   const toggle =
  //     document.querySelector(".menu-toggle");

  //   const linksContainer =
  //     document.querySelector(".menu-linki");

  //   const menuLinks =
  //     document.querySelectorAll(".menu-linki a");


  //   /* =========================
  //     HAMBURGER
  //     ========================= */

  //   if (
  //     toggle instanceof HTMLButtonElement &&
  //     linksContainer instanceof HTMLElement
  //   ) {

  //     toggle.addEventListener("click", () => {

  //       const isOpen =
  //         linksContainer.classList.toggle("open");

  //       toggle.setAttribute(
  //         "aria-expanded",
  //         isOpen ? "true" : "false"
  //       );

  //     });


  //     menuLinks.forEach((link) => {

  //       link.addEventListener("click", () => {

  //         linksContainer.classList.remove("open");

  //         toggle.setAttribute(
  //           "aria-expanded",
  //           "false"
  //         );

  //       });

  //     });

  //   }


  //   /* =========================
  //     AKTYWNY LINK
  //     ========================= */

  //   const updateActiveMenuLink = () => {

  //     const sectionIds = [
  //       "ceremonia",
  //       "rejs",
  //       "wesele",
  //       "nasza_historia",
  //       "rsvp"
  //     ];

  //     const marker =
  //       window.innerWidth <= 800
  //         ? 100
  //         : 110;

  //     let activeId = "";


  //     sectionIds.forEach((id) => {

  //       const section =
  //         document.getElementById(id);

  //       if (!section) {
  //         return;
  //       }

  //       const rect =
  //         section.getBoundingClientRect();

  //       if (
  //         rect.top <= marker &&
  //         rect.bottom > marker
  //       ) {
  //         activeId = id;
  //       }

  //     });


  //     menuLinks.forEach((link) => {

  //       if (!(link instanceof HTMLAnchorElement)) {
  //         return;
  //       }

  //       link.classList.toggle(
  //         "active",
  //         link.getAttribute("href") === `#${activeId}`
  //       );

  //     });

  //   };


  //   window.addEventListener(
  //     "scroll",
  //     updateActiveMenuLink,
  //     {
  //       passive: true
  //     }
  //   );

  //   window.addEventListener(
  //     "resize",
  //     updateActiveMenuLink
  //   );

  //   updateActiveMenuLink();

  // }

  function initAnimations() {
    initRevealAnimations();
    initWritingTitles();
    // initMenu();
  }


  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAnimations
    );
  } else {
    initAnimations();
  }


  /*
    Przy zmianie szerokości okna
    przeliczamy nagłówki ponownie.
  */
  window.addEventListener(
    "resize",
    fitWritingTitles
  );


  /*
    Po pełnym załadowaniu fontów
    też przeliczamy szerokość,
    bo WindSong może załadować się
    chwilę później.
  */
  if (document.fonts) {
    document.fonts.ready.then(() => {
      fitWritingTitles();
    });
  }
</script>